// This file should never have any imports

export function iconToString(icon: string[] | string): string[] {
  const iconString = Array.isArray(icon)
    ? icon.map((s, i) => (i === 0 ? shortToLong(s) : s))
    : icon.split(':')
  return iconString
}
export function shortToLong(icon: string): string {
  switch (icon) {
    case 'fas':
      return 'fa-solid'
    case 'fab':
      return 'fa-brands'
    case 'fa':
      return 'fa'
    // return 'fa-regular'
    default:
      return icon
  }
}
